import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import ServiceList from 'components/Lists/ServiceList'
import TextInput from 'components/Inputs/TextInput'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { FaPlus } from 'react-icons/fa'
import { ListContainer, FilterContainer } from '../styles'

function Services () {
  const [query, setQuery] = useState ('')
  const [loading, setLoading] = useState (true)
  const [services, setServices] = useState ([])
  const token = AuthService.getToken ()
  const navigate = useNavigate ()
  //const [category, setCategory] = useState (localStorage.getItem ('service_category'))

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [query])

  const getData = async () => {
    try {
      setLoading (true)

      const { data: services } = await cutileiApi.get (
        `/services?name=${encodeURIComponent (query)}`, requestConfig
      )

      setServices (services)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <ListContainer>
      <FilterContainer>
        <TextInput
          value={query}
          placeholder='Pesquisar por nome'
          isClearable={true}
          onChange={e => setQuery (e.target.value)}
          onClear={() => setQuery ('')}
          containerStyle={{width: 280}}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
        />
        <SecondaryButton
          label='Novo serviço'
          leftIcon={<FaPlus size={12} color='#FFC100' style={{marginBottom: 2}}/>}
          onClick={() => navigate ('/admin/services/new')}
          width={140}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 30}}/> :
        <ServiceList services={services}/>
      }
    </ListContainer>
  )
}

export default Services
